var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.courseId && _vm.biz)?_c('div',[_vm._v("You are editing "+_vm._s(_vm.count)+" item"),(_vm.count > 1)?_c('span',[_vm._v("s")]):_vm._e(),_c('span',{staticClass:"ml-1"},[_vm._v("under the course: "+_vm._s(_vm.courseName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }